// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"23652":"d1ee9b24ec63530a","50717":"88e2654452ac3916"}[chunkId] + ".css";
};